import { gql } from '@apollo/client';
export const DOCUMENTAL_GROUP_TEMPLATE_FIELDS = gql`
  fragment DocumentalGroupTemplateFields on DocumentalGroupTemplateDto {
    id
    name
    businessUnitName
    documentTypes {
      documentTypeName
      documentTypeCode
    }
  }
`;
export const DOCUMENT_EDM_FIELDS = gql`
  fragment DocumentEdmFields on DocumentEdmDto {
    businessUnitName
    level
    archiveName
    documentTypeId
    archiveId
    documentTypeCode
    createdBy
    archiveExtension
    name
    id
    state
    documentTypeName
  }
`;
export const DOCUMENTAL_VALIDATION_STATISTICS_FIELDS = gql`
  fragment DocumentalValidationStatisticsFields on DocumentalValidationStatisticsDto {
    lastEvaluationDate
    documentsPresentInDocumentalGroups
    validationResult
    techinalValidationResultMap
    numNoValidationDocs
    numInvalidatedDocs
    actualInvalidatedDocsUsedInDocumentalGrops
    numValidatedDocs
    validationsNeededInDocumentalGroups
    technicalValidationsPresentInDocumentalGroups
    documentsNeededInDocumentalGroups
    technicalValidationsNeededInDocumentalGroups
    typologyAndDocuments
    validationsPresentInDocumentalGroups
    typologyResultMap
  }
`;
export const PENDING_DOCUMENT_REQUEST_ID_LIST_FIELDS = gql`
  fragment PendingDocumentRequestIdListFields on DocumentRequestDto {
    id
    status
    relatedId
    relatedObjectTypeId
    consideredId
    consideredObjectTypeId
    documentalGroupId
    documentTypeId
  }
`;
export const DOCUMENTAL_VALIDATION_LINE_FIELDS = gql`
  ${PENDING_DOCUMENT_REQUEST_ID_LIST_FIELDS}
  fragment DocumentalValidationLineFields on DocumentalValidationLineDto {
    ignored
    quantity
    documentTypeId
    documentTypeCode
    documentTypeFormatList
    id
    documentTypeName
    status
    pendingDocumentRequestIdList {
      ...PendingDocumentRequestIdListFields
    }
  }
`;
export const DOCUMENTAL_VALIDATION_FIELDS = gql`
  ${DOCUMENTAL_VALIDATION_LINE_FIELDS}
  ${DOCUMENTAL_VALIDATION_STATISTICS_FIELDS}
  ${PENDING_DOCUMENT_REQUEST_ID_LIST_FIELDS}
  fragment DocumentalValidationFields on DocumentalValidationDto {
    id
    documentalGroupName
    consideredId
    consideredObjectTypeId
    relatedObjectTypeId
    relatedId
    personalization
    validation
    groupValidation
    pendingDocumentRequestIdList {
      ...PendingDocumentRequestIdListFields
    }
    documentalGroupCode
    documentalGroupId
    documentalValidationLines {
      ...DocumentalValidationLineFields
    }
    evaluationResults {
      ...DocumentalValidationStatisticsFields
    }
  }
`;